function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMediaRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 10h3V8h-3v2zm0 14h3v-2h-3v2zm-5-14h3V8h-3v2zm-4 10v-8l7 4-7 4zm4 4h3v-2h-3v2zm-5 0h3v-2h-3v2zM7 10h3V8H7v2zm0 14h3v-2H7v2zm5-14h3V8h-3v2zm16-6H4a2 2 0 00-2 2v20a2 2 0 002 2h24a2 2 0 002-2V6a2 2 0 00-2-2z",
    fill: props.color
  }));
}

export default SvgIconMediaRexFilled;